import { Talk } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function Talks({ talks }: { talks: Talk[] }): JSX.Element {
  return (
    <ManPage
      name="talks"
      manual="Spoken Word"
      sections={[
        { heading: 'NAME', body: 'talks - presentations, podcasts, interviews' },
        {
          heading: 'ENTRIES',
          body: (
            <>
              {talks.map((t, i) => (
                <div key={i}>
                  <div>
                    <span className="man-sub">{t.date}</span>
                    {'  '}
                    <a href={t.url}>{t.title}</a>
                  </div>
                  <div>{t.description}</div>
                  {'\n'}
                </div>
              ))}
            </>
          )
        }
      ]}
    />
  );
}
